import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

const WrapperStyles = ({ theme }) => ({
  backgroundColor: theme.palette.background.grey.light,
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: 16,
  padding: '16px',
  [theme.breakpoints.up('md')]: {
    padding: '24px'
  }
});

export const WrapperStyled = styled(Box)(WrapperStyles);
